<template>
  <div style="background-color: #eeeeee; padding-bottom: 100px">
    <img style="display: block; margin: 0 auto" src="../../assets/banner9.png" alt="" />
    <div class="main" v-if="languageCode == 'zh'">
      <ul class="Breadcrumb">
        <li @click="backPage('/home')">首页</li>
        <li>></li>
        <li>公司介绍</li>
      </ul>
      <h3 class="tab_title">公司简介</h3>
      <p style="margin-bottom: 20px">{{ form.content }}</p>
      <div v-if="technologyList.length > 0" class="promotional">
        <video
          ref="video"
          style="width: 100%"
          muted="muted"
          class="video"
          :poster="form.coverImage"
          @timeupdate="onTimeupdate"
          @keydown="onKeydown"
          :src="form.video"
          :controlsList="controlsList"
          type="video/mp4"
          controls="controls"
        >
          <p>你的浏览器不支持video标签.</p>
        </video>
        <!-- <span>{{ technologyList[0].name }}</span> -->
      </div>
      <h3 class="tab_title">公司资质</h3>

      <img style="margin: 20px 0 20px 0" :src="form.titleImage" alt="" />
      <!-- <img style="margin:20px 0" src="../../assets/img29.jpg" alt="" /> -->
      <h3 class="tab_title">投资伙伴</h3>
    </div>
    <div class="main" v-else>
      <ul class="Breadcrumb">
        <li @click="backPage('/home')">Home</li>
        <li>></li>
        <li>Company Introduction</li>
      </ul>
      <h3 class="tab_title">Company Profile</h3>
      <p style="margin-bottom: 20px">{{ form.content }}</p>
      <div v-if="technologyList.length > 0" class="promotional">
        <video
          ref="video"
          style="width: 100%"
          muted="muted"
          class="video"
          :poster="form.coverImage"
          @timeupdate="onTimeupdate"
          @keydown="onKeydown"
          :src="form.video"
          :controlsList="controlsList"
          type="video/mp4"
          controls="controls"
        >
          <p>Your browser does not support the video tag.</p>
        </video>
        <!-- <span>{{ technologyList[0].name }}</span> -->
      </div>
      <h3 class="tab_title">Company Qualifications</h3>

      <img style="margin: 20px 0 20px 0" :src="form.titleImage" alt="" />
      <!-- <img style="margin:20px 0" src="../../assets/img29.jpg" alt="" /> -->
      <h3 class="tab_title">Investment Partners</h3>
    </div>

    <div
      class="swiper_wrap anTransform"
      style="width: 1300px; margin: 36px auto 0; overflow: hidden"
    >
      <swiper id="media" class="homeSwiper" :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in swiperList" :key="index">
          <img :src="item.coverImage" alt="" />
        </swiper-slide>
      </swiper>
      <div class="fleft bg"></div>
      <div class="fright bg"></div>
    </div>
  </div>
</template>
<script>
// import { backPage } from "@/utils/common";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getVideoList, getPromotionalVideo } from "../../api/index";

// import 'swiper/dist/css/swiper.css'
export default {
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    controlsList() {
      // nodownload: 隐藏下载按钮
      // noremoteplayback: 隐藏远程播放
      // 注意：没有直接隐藏进度条的属性，需要配合 CSS
      return "nodownload";
    },
  },
  data() {
    return {
      technologyList: [],
      swiperOption: {
        slidesPerView: 4.5,
        slidesPerColumn: 2,
        spaceBetween: 10,
        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true,
        // },
        // autoplay: {
        //     delay: 1000,
        //     stopOnLastSlide: false,
        //     disableOnInteraction: true,
        // },
      },
      swiperList: [
        { coverImage: require("../../assets/logo/logo1.png") },
        { coverImage: require("../../assets/logo/logo2.png") },
        { coverImage: require("../../assets/logo/logo8.png") },
        { coverImage: require("../../assets/logo/logo3.png") },
        { coverImage: require("../../assets/logo/logo4.png") },
        { coverImage: require("../../assets/logo/logo5.png") },
        { coverImage: require("../../assets/logo/logo6.png") },
        { coverImage: require("../../assets/logo/logo7.png") },
        { coverImage: require("../../assets/logo/logo9.png") },
        { coverImage: require("../../assets/logo/logo10.png") },
        { coverImage: require("../../assets/logo/logo11.png") },
        { coverImage: require("../../assets/logo/logo12.png") },
        { coverImage: require("../../assets/logo/logo13.png") },
        { coverImage: require("../../assets/logo/logo14.png") },
        { coverImage: require("../../assets/logo/logo15.png") },
      ],
      form: {},
      languageCode: "",
    };
  },
  mounted() {
    const lang = this.$i18nState.locale; // ✅ 正确的语言获取方式
    this.languageCode = lang;
    // document.getElementsByClassName('homeSwiper')[0].removeAttribute('overflow')
    // this.$refs.mySwiper.removeClass('swiper-container')
    getVideoList({ promotional: "1" }).then((res) => {
      this.technologyList = res.rows;
    });
    getPromotionalVideo({ languageCode: lang == "zh" ? "zh-CN" : "en-US" }).then(
      (res) => {
        console.log(res.data);
        this.form = res.data;
      }
    );
  },
  methods: {
    getLocalizedPath(rawPath) {
    const currentLang = this.$i18nState.locale || "zh";
    // 如果路径已经以 /zh 或 /en 结尾，则直接返回
    if (/\/(zh|en)$/.test(rawPath)) {
      return rawPath;
    }
    // 移除路径末尾多余的斜杠，然后添加语言
    const base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
    return `${base}/${currentLang}`;
    },
    backPage(page) {
      if (page == "-1") {
        this.$router.go(-1);
      } else {
        const fullPath = this.getLocalizedPath(page);
        this.$router.replace({path:fullPath});
        // this.$router.push(page);
      }
    },
    onTimeupdate(event) {
      const video = event.target;
      const currentTime = video.currentTime;

      // 1. 更新已观看的最大进度（仅当正常播放时）
      if (currentTime > this.maxWatchedTime) {
        // 允许 1 秒内的误差，视为正常播放
        if (currentTime - this.maxWatchedTime < 1) {
          this.maxWatchedTime = currentTime;
        } else {
          // 2. 如果当前时间远大于最大进度（比如跳过了好几秒），说明是拖拽或快进，强制拉回
          video.currentTime = this.maxWatchedTime;
        }
      }
    },
    onKeydown(event) {
      // 阻止键盘右键（快进键，keyCode 39）的默认行为
      if (event.keyCode === 39) {
        event.preventDefault();
        // 也可以在这里加上强制拉回的逻辑
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/* 隐藏进度条 */
video::-webkit-media-controls-timeline {
  display: none !important;
}
video::-webkit-media-controls-current-time-display,
video::-webkit-media-controls-time-remaining-display {
  display: none !important; /* 可选：隐藏时间显示 */
}
.title {
  border-left: 10px solid #d60e4c;
  line-height: 32px;
  text-indent: 30px;
  font-weight: bold;
  font-size: 36px;
  margin: 30px 0;
}

p {
  line-height: 32px;
  font-size: 16px;
}

.swiper_wrap {
  position: relative;

  .bg {
    height: 100%;
    position: absolute;
    width: 150px;
    top: 0;
    z-index: 999;
  }

  .bg.fleft {
    background-image: linear-gradient(to right, #eeeeee, transparent);
    left: 0;
  }

  .bg.fright {
    background-image: linear-gradient(to left, #eeeeee, transparent);
    right: 0;
  }
}
#media {
  animation: rolling 10s infinite linear;
}
#media:hover {
  animation-play-state: paused;
}
@keyframes rolling {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-800px);
  }
}
.homeSwiper {
  overflow: initial !important;
}
.promotional {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/about/index.vue